import { BaseComponent } from '../core/BaseComponent';

export interface TooltipOptions {
  placement: 'top' | 'bottom' | 'left' | 'right';
  trigger: 'hover' | 'click';
  delay: number;
  offset: [number, number];
}

export class Tooltip extends BaseComponent<TooltipOptions> {
  private tooltip: HTMLElement | null = null;
  private showTimeout?: any;

  protected getDefaultOptions(): TooltipOptions {
    return {
      placement: 'top',
      trigger: 'hover',
      delay: 200,
      offset: [0, 8]
    };
  }
  
  protected bindEvents(): void {
    if (this.options.trigger === 'hover') {
      this.element.addEventListener('mouseenter', () => this.handleMouseEnter());
      this.element.addEventListener('mouseleave', () => this.handleMouseLeave());
    } else {
      this.element.addEventListener('click', (e) => {
        e.preventDefault();
        this.toggle();
      });
    }
  }
  
  public toggle(): void {
    this.tooltip ? this.hide() : this.show();
  }

  public show(): void {
    if (this.tooltip) return;
    
    this.createTooltip();
    this.positionTooltip();
    this.tooltip!.classList.add('show');
    this.emit('show');
  }
  
  public hide(): void {
    if (!this.tooltip) return;
    
    this.tooltip.classList.remove('show');
    setTimeout(() => {
      if (this.tooltip) {
        this.tooltip.remove();
        this.tooltip = null;
      }
      this.emit('hide');
    }, 200);
  }
  
  private createTooltip(): void {
    this.tooltip = document.createElement('div');
    this.tooltip.className = `tooltip tooltip-${this.options.placement}`;
    this.tooltip.textContent = this.element.getAttribute('data-fz-tooltip') || (this.element as any).title || '';
    document.body.appendChild(this.tooltip);
  }
  
  private positionTooltip(): void {
    if (!this.tooltip) return;
    const elementRect = this.element.getBoundingClientRect();
    const tooltipRect = this.tooltip.getBoundingClientRect();
    
    let top, left;
    
    switch (this.options.placement) {
      case 'top':
        top = elementRect.top - tooltipRect.height - this.options.offset[1];
        left = elementRect.left + (elementRect.width - tooltipRect.width) / 2;
        break;
      case 'bottom':
        top = elementRect.bottom + this.options.offset[1];
        left = elementRect.left + (elementRect.width - tooltipRect.width) / 2;
        break;
      case 'left':
        top = elementRect.top + (elementRect.height - tooltipRect.height) / 2;
        left = elementRect.left - tooltipRect.width - this.options.offset[0];
        break;
      case 'right':
        top = elementRect.top + (elementRect.height - tooltipRect.height) / 2;
        left = elementRect.right + this.options.offset[0];
        break;
      default:
        top = 0; left = 0;
    }
    
    this.tooltip.style.position = 'fixed';
    this.tooltip.style.top = `${top}px`;
    this.tooltip.style.left = `${left}px`;
    this.tooltip.style.zIndex = '1100';
  }
  
  private handleMouseEnter(): void {
    this.showTimeout = setTimeout(() => this.show(), this.options.delay);
  }
  
  private handleMouseLeave(): void {
    clearTimeout(this.showTimeout);
    this.hide();
  }
}
